function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import Geometry from './Geometry';
import GeometryCollection from './GeometryCollection';
import Polygonal from './Polygonal';
import ArrayList from '../../../../java/util/ArrayList';
var MultiPolygon = /*#__PURE__*/function (_GeometryCollection) {
  function MultiPolygon() {
    var _this;
    _classCallCheck(this, MultiPolygon);
    _this = _callSuper(this, MultiPolygon);
    MultiPolygon.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(MultiPolygon, _GeometryCollection);
  return _createClass(MultiPolygon, [{
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0];
        var tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) {
          return false;
        }
        return _superPropGet(MultiPolygon, "equalsExact", this, 1).call(this, other, tolerance);
      } else return _superPropGet(MultiPolygon, "equalsExact", this, 1).apply(this, arguments);
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return 1;
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_MULTIPOLYGON;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 2;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var n = this._geometries.length;
      var revGeoms = new Array(n).fill(null);
      for (var i = 0; i < this._geometries.length; i++) {
        revGeoms[i] = this._geometries[i].reverse();
      }
      return this.getFactory().createMultiPolygon(revGeoms);
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (this.isEmpty()) {
        return this.getFactory().createMultiLineString();
      }
      var allRings = new ArrayList();
      for (var i = 0; i < this._geometries.length; i++) {
        var polygon = this._geometries[i];
        var rings = polygon.getBoundary();
        for (var j = 0; j < rings.getNumGeometries(); j++) {
          allRings.add(rings.getGeometryN(j));
        }
      }
      var allRingsArray = new Array(allRings.size()).fill(null);
      return this.getFactory().createMultiLineString(allRings.toArray(allRingsArray));
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_MULTIPOLYGON;
    }
  }, {
    key: "copy",
    value: function copy() {
      var polygons = new Array(this._geometries.length).fill(null);
      for (var i = 0; i < polygons.length; i++) {
        polygons[i] = this._geometries[i].copy();
      }
      return new MultiPolygon(polygons, this._factory);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return MultiPolygon;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Polygonal];
    }
  }]);
}(GeometryCollection);
export { MultiPolygon as default };
MultiPolygon.constructor_ = function () {
  var polygons = arguments[0];
  var factory = arguments[1];
  GeometryCollection.constructor_.call(this, polygons, factory);
};
MultiPolygon.serialVersionUID = -551033529766975875;